export enum IntervalTypeEnum {
    OVERLAP = 'Overlap',
    RANGE = 'Range',
    STRICT = 'Strict'
}
